export async function addOrUpdateProduct(productData, userId) {
  try {
    const payload = {
      ...productData,
      userId: userId,
      availabilities: productData.availabilities.map((availability) => {
        const date = new Date(availability.availableDate);
        date.setHours(0, 0, 0, 0); // Assure que l'heure est minuit localement

        return {
          availableDate: date.toLocaleDateString("fr-CA"), // Format YYYY-MM-DD
          userId: userId,
          productId: productData.productId,
          id: availability.id,
        };
      }),
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Products/WithAvailabilities`,
      {
        method: "POST", // Update si l'ID existe
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload), // Corps de la requête
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(
      "Erreur lors de l'ajout ou la mise à jour du produit :",
      error
    );
    throw error;
  }
}

export async function fetchProductsFromApi(signal) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Products`,
      { signal }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      return null; // Requête annulée
    }
    console.error("Erreur lors de la récupération des produits :", error);
    throw error;
  }
}

export async function fetchAvailableItems(
  userLat,
  userLong,
  selectedCategories,
  selectedDates
) {
  try {
    const payload = {
      userLatitude: userLat,
      userLongitude: userLong,
      categoryIds: selectedCategories,
      dates: selectedDates,
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Search/search`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch available items.");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching available items:", error.message);
    return [];
  }
}

export async function getProductsWithAvailabilities(userId) {
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/api/Products/ForProvider/${userId}`
  );
  if (!response.ok)
    throw new Error("Erreur lors de la récupération des produits.");
  return await response.json();
}

export async function getProductByIdWithAvailabilities(productId) {
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/api/Products/${productId}`
  );
  if (!response.ok) throw new Error("Produit introuvable.");
  return await response.json();
}

export async function getProductsByCompanyId(companyId) {
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/api/Products/ByCompany?companyId=${companyId}`
  );

  const text = await response.text();

  if (!response.ok) {
    throw new Error(`Erreur HTTP ${response.status}: ${text}`);
  }

  // Retourner [] si vide, sinon parser le JSON
  if (!text.trim()) {
    return [];
  }

  return JSON.parse(text);
}
